import { render, staticRenderFns } from "./CompraEdicaoTags.vue?vue&type=template&id=3053472e"
import script from "./CompraEdicaoTags.vue?vue&type=script&lang=js"
export * from "./CompraEdicaoTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports